import { loadScript } from './load'

const GTM_CONTAINER_ID = 'GTM-TVLLS36'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

export async function loadGtm(): Promise<void> {
  const w = window
  w.dataLayer = w.dataLayer || []
  w.gtag = function (...args: unknown[]) {
    w.dataLayer!.push(args)
  }
  w.gtag('js', new Date())

  await loadScript(`https://www.googletagmanager.com/gtag/js?id=${GTM_CONTAINER_ID}`, { id: 'gtag-script' })
  w.gtag('config', GTM_CONTAINER_ID)
}
